import { api } from "./api";

// First-touch attribution: the first ad/source that brought a visitor wins.
export function getAttribution() {
  const params = new URLSearchParams(window.location.search);
  const src = params.get("utm_source");
  if (src && !localStorage.getItem("zaf_attr")) {
    localStorage.setItem(
      "zaf_attr",
      JSON.stringify({
        utm_source: src,
        utm_medium: params.get("utm_medium") || "",
        utm_campaign: params.get("utm_campaign") || "",
        referrer: document.referrer || "",
      })
    );
  }
  try {
    return JSON.parse(localStorage.getItem("zaf_attr") || "{}");
  } catch {
    return {};
  }
}

// Fire once per browser to count a unique visitor against its source.
export async function trackVisit() {
  getAttribution(); // capture UTM if present on this load
  if (localStorage.getItem("zaf_visit_sent")) return;
  let vid = localStorage.getItem("zaf_vid");
  if (!vid) {
    vid =
      (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("zaf_vid", vid);
  }
  const attr = getAttribution();
  try {
    await api.post("/track/visit", {
      visitor_id: vid,
      utm_source: attr.utm_source || null,
      utm_medium: attr.utm_medium || null,
      utm_campaign: attr.utm_campaign || null,
      referrer: document.referrer || "",
      path: window.location.pathname,
    });
    localStorage.setItem("zaf_visit_sent", "1");
  } catch (e) {
    /* non-blocking */
  }
}
